import { Entity, Column, PrimaryGeneratedColumn, Unique, ManyToOne, JoinColumn, OneToOne } from 'typeorm'
import QuestionOption from '../survey/QuestionOption'

import TestConfiguration from './TestConfiguration'

@Entity('config_livecharts_options')
@Unique('IDX_UNQ_DISTINCT_OPTIONS_CONFIG', ['option'])
export default class OptionConfiguration {
  @PrimaryGeneratedColumn('uuid')
  id!: string

  @Column({ name: 'created_at' })
  createdAt!: Date

  @Column({ name: 'title' })
  title?: string

  @ManyToOne(type => TestConfiguration, testConfig => testConfig.optionConfigs)
  @JoinColumn({ name: 'config_livecharts_test_id' })
  testConfig!: TestConfiguration

  @OneToOne(type => QuestionOption, option => option.configuration)
  @JoinColumn({ name: 'question_options_id' })
  option!: QuestionOption

  @Column({ name: 'question_options_id' })
  questionOptionId!: number
}
